import {Inspector} from '@observablehq/runtime'

export const FULFILLED = 'fulfilled'
export const REJECTED = 'rejected'
export const PENDING = 'pending'

export class FragInspector extends Inspector {
  constructor (element, setFn) {
    super(element)

    this.setFn = setFn;
  }

  fulfilled (value, name) {
    super.fulfilled(value, name);
    // console.log('FULLFILLED', name, value)

    this.setFn(FULFILLED, name, value)
  }

  rejected (error, name) {
    super.rejected(error, name);

    this.setFn(REJECTED)
  }

  pending () {
    super.pending();

    this.setFn(PENDING)
  }
}
